<template>
    <div>
        <el-dialog
         title="添加商品"
        :visible.sync="visible"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        width="1000px"
        :before-close="handleClose"
         >
            <el-form :model="filters" class="toolbar formStyle" ref="filters" label-width="80px">
                <el-row style="padding-bottom: 0px;">
                    <el-col :span="6" style="display:flex">
                        <el-select v-model="searchInputValue" placeholder="请选择" @change="searchInputChanged" style="width:110px;margin-right:10px">
                              <el-option
                                v-for="item in searchInputList"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value"
                              >                 
                              </el-option>
                        </el-select>
                        <el-input v-model="filters.sptm" v-show="searchInputValue == 1" clearable style="flex:1"></el-input>
                        <el-input v-model="filters.sku" v-show="searchInputValue == 2" clearable style="flex:1"></el-input>
                        <el-input v-model="filters.spu" v-show="searchInputValue == 3" clearable style="flex:1"></el-input>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="商品名称" prop="itemName">
                            <el-input v-model="filters.itemName" placeholder="请输入商品名称" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="品牌" prop="brand">
                            <el-select v-model="filters.brand">
                                <el-option
                                    v-for="item in statusList"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.value"
                                    >                 
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="商家类目" prop="sjlm">
                            <el-select v-model="filters.sjlm">
                                <el-option
                                    v-for="item in statusList"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.value"
                                    >                 
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col style="text-align:right">
                        <el-button type="primary"  @click="search()">查询</el-button>
                        <el-button @click="reset()">重置</el-button>
                    </el-col>
                </el-row>
            </el-form>
            <div>
                <p style="font-size: 16px;padding-top: 10px;padding-left: 3px;">
                    选择商品
                </p>
                <el-table :data="dataList" class="listTowline singleClick" highlight-current-row v-loading="listLoading" style="width: 100%;">
                    <el-table-column type="selection" min-width="55"></el-table-column>
                    <el-table-column prop="contractAppid" label="SKU" min-width="100"></el-table-column>
                    <el-table-column prop="contractNo" label="SPU" min-width="100"></el-table-column>
                    <el-table-column prop="revNo" label="商品条码" min-width="120"></el-table-column>
                    <el-table-column prop="status" label="商品名称" min-width="80"></el-table-column>
                    <el-table-column prop="creationDate" label="商家类目" min-width="80"></el-table-column>
                    <el-table-column prop="TBH_SPACEMODE" label="品牌" min-width="80"></el-table-column>
                </el-table>
                <!-- 分页 -->
                <pagination
                    :total="totalNum"
                    :page.sync="pageSize"
                    :limit.sync="pageRows"
                    @pagination="getRows()"
                />
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click.native="handleSave()">确定</el-button>
                <el-button @click.native="handleClose()">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
//分页组件
import Pagination from '@/components/Pagination';
export default {
    data(){
        return{
            filters:{
                sptm:'',
                sku:'',
                spu:'',
                itemName:'',
                brand:'',
                sjlm:'',
            },
            searchInputValue:1,
            searchInputList:[],
            dataList:[], //表格数据
            listLoading: false,
            pageSize: 1,      //分页信息
            pageRows: 10,
            totalNum: 0,
        }
    },
    components: {
        Pagination,
    },
    props:{
        visible:{
            type:Boolean,
            default:false
        }
    },
    methods:{
        //关闭
        handleClose() {
            this.$emit("update:visible", false);
        },
        searchInputChanged(){

        }
    }
}
</script>
<style lang="scss">
    .formStyle{
        overflow: hidden;
        padding-bottom: 15px;
        border-bottom: 1px solid #ccc;
    }
</style>


// WEBPACK FOOTER //
// src/views/newProductApplication/dialog/addgoods.vue